<script setup>
    const props = defineProps({
        setupFinished: { type: Boolean, default: false, },
        locked: { type: Boolean, default: false, },
        active: { type: Boolean, default: false, },
        completed: { type: Boolean, default: false, },
        inProgress: { type: Boolean, default: false, },
        excludedFromInstallation: { type: Boolean, default: false, },
        href: [String, Boolean],
    });

    function link() {
        if (props.completed || props.inProgress || props.excludedFromInstallation) {
            return props.href;
        } else {
            return '';
        }
    }
</script>

<template>
    <li class="py-3 md:px-6">
        <inertia-link :href="link()" class="md:rounded-md md:border w-full block md:py-4 md:px-2 inline-flex text-[#5c6675] tracking-wide flex-col justify-center items-center relative"
            :class="{
                'cursor-not-allowed border-blue font-avertaBold': locked,
                'md:hover:font-averta border-blue font-avertaBold': !locked && !active,
                'md:border md:font-averta md:border-gray bg-blue': active,
                'text-red border-blue': completed,
            }">
            <slot name="icon"></slot>
            <span class="text-sm mt-2 self-center"><slot></slot></span>

            <svg v-if="locked" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 absolute text-[#5c6675] left-[5px] top-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>

            <svg v-if="inProgress" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 absolute left-[5px] top-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>

            <svg v-if="completed && !setupFinished" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-800 absolute text-[#5c6675] left-[5px] top-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        </inertia-link>
    </li>
</template>
